import { render, staticRenderFns } from "./CalendarStub.vue?vue&type=template&id=73bc3fae&scoped=true&"
import script from "./CalendarStub.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalendarStub.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CalendarStub.vue?vue&type=style&index=0&id=73bc3fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc3fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73bc3fae')) {
      api.createRecord('73bc3fae', component.options)
    } else {
      api.reload('73bc3fae', component.options)
    }
    module.hot.accept("./CalendarStub.vue?vue&type=template&id=73bc3fae&scoped=true&", function () {
      api.rerender('73bc3fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components/WorkplaceOrServiceCalendar/components/CalendarStub.vue"
export default component.exports